"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var camelize_style_1 = require("./util/camelize-style");
var hyphenate_style_1 = require("./util/hyphenate-style");
var _1 = require("../_");
function getComputedStyle(node) {
    var doc = node.ownerDocument;
    if (doc) {
        if (!('defaultView' in doc)) {
            throw new Error('IE8 is not supported');
        }
        if (doc.defaultView && doc.defaultView.opener) {
            return doc.defaultView.getComputedStyle(node);
        }
    }
    return window.getComputedStyle(node);
}
exports.getComputedStyle = getComputedStyle;
function removeStyle(node, key) {
    if (node && 'removeProperty' in node.style) {
        node.style.removeProperty(key);
    }
    else {
        node.style['removeAttribute'](key);
    }
}
exports.removeStyle = removeStyle;
function getCss(node, property) {
    return node.style[camelize_style_1.camelizeStyle(property)] || getComputedStyle(node).getPropertyValue(hyphenate_style_1.hyphenateStyle(property));
}
exports.getCss = getCss;
function setCss(node, property, value) {
    if (!value && value !== 0) {
        removeStyle(node, hyphenate_style_1.hyphenateStyle(property));
    }
    else {
        node.style.cssText += ';' + hyphenate_style_1.hyphenateStyle(property) + ':' + value;
    }
}
exports.setCss = setCss;
// eslint-disable-next-line @typescript-eslint/ban-types
function setStyle(node, props) {
    var css = '';
    for (var key in props) {
        if (_1.has(props, key)) {
            !props[key] && props[key] !== 0
                ? removeStyle(node, hyphenate_style_1.hyphenateStyle(key))
                : (css += hyphenate_style_1.hyphenateStyle(key) + ':' + props[key] + ';');
        }
    }
    node.style.cssText += ';' + css;
    return css;
}
exports.setStyle = setStyle;
